// extracted by mini-css-extract-plugin
module.exports = {"SArticleImage":"KulNr_SArticleImage__W6cL6","STextContainer":"KulNr_STextContainer__X3V0L","SIngress":"KulNr_SIngress__tlu2p"};